//
// Copyright © 2026 PlayJoy Studios.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

/**
 * @public
 *
 * Version of the module: header of the console, GET /_ai/health and the start line of the
 * service log all read it from here. Semver of its own, apart from the version of the fork.
 */
export const aiConsoleVersion = '0.15.0'
